// extracted by mini-css-extract-plugin
module.exports = {"shop":"Channel_shop__2UxJW"};